module.exports = __webpack_public_path__ + "img/12.0bbe915c.jpg";